
import { Button } from '@/components/ui/button';
import { OnboardingData } from '../OnboardingFlow';

interface SocialIntegrationStepProps {
  data: OnboardingData;
  updateData: (data: Partial<OnboardingData>) => void;
  onNext: () => void;
  onBack: () => void;
}

const SocialIntegrationStep = ({ updateData, onNext, onBack }: SocialIntegrationStepProps) => {
  const handleSocialLogin = (provider: 'google' | 'apple' | 'facebook') => {
    updateData({ socialLogin: provider });
    onNext();
  };

  const handleSkip = () => {
    updateData({ socialLogin: 'skip' });
    onNext();
  };

  return (
    <div className="text-center space-y-8">
      <h2 className="text-2xl font-bold text-gray-800">
        Want to sign up with your Google, Apple, or Facebook account?
      </h2>
      
      <div className="space-y-4">
        <Button
          onClick={() => handleSocialLogin('google')}
          className="w-full h-12 text-lg font-semibold bg-white hover:bg-gray-50 text-gray-800 border-2 border-gray-200 hover:border-gray-300 rounded-xl transition-all duration-300"
        >
          Continue with Google
        </Button>
        
        <Button
          onClick={() => handleSocialLogin('apple')}
          className="w-full h-12 text-lg font-semibold bg-black hover:bg-gray-900 text-white rounded-xl transition-all duration-300"
        >
          Continue with Apple
        </Button>
        
        <Button
          onClick={() => handleSocialLogin('facebook')}
          className="w-full h-12 text-lg font-semibold bg-blue-600 hover:bg-blue-700 text-white rounded-xl transition-all duration-300"
        >
          Continue with Facebook
        </Button>
        
        <div className="flex items-center my-6">
          <div className="flex-1 border-t border-gray-300"></div>
          <span className="px-4 text-gray-500 text-sm">or</span>
          <div className="flex-1 border-t border-gray-300"></div>
        </div>
        
        <Button
          onClick={handleSkip}
          variant="ghost"
          className="w-full h-10 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-xl transition-all duration-300"
        >
          Skip for now
        </Button>
      </div>
      
      <Button
        onClick={onBack}
        variant="ghost"
        className="w-full h-10 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-xl transition-all duration-300"
      >
        Back
      </Button>
    </div>
  );
};

export default SocialIntegrationStep;
